<template>
  <div class="auto-extension-panel">
    <div class="auto-extension-panel__row">
      <span class="auto-extension-panel__label">自動延長</span>
      <auto-extension-toggle
        :table-id="tableId"
        :value="autoExtensionEnabled"
        @updated:table="$emit('updated:table', $event)"
      />
    </div>

    <div
      v-if="autoExtensionEnabled && autoExtensionCourseName"
      class="auto-extension-panel__course"
    >
      延長：{{ autoExtensionCourseName }}
    </div>

    <auto-extension-countdown
      :table-id="tableId"
      :expire-at="expireAt"
      :auto-extension-enabled="autoExtensionEnabled"
      :auto-extension-course-name="autoExtensionCourseName"
      :notice-minutes="noticeMinutes"
      class="mt-1"
      @updated:table="$emit('updated:table', $event)"
    />
  </div>
</template>

<script>
import AutoExtensionToggle from '@/views/components/table/TableShowDrawer/Overview/AutoExtensionToggle.vue'
import AutoExtensionCountdown from '@/views/components/table/AutoExtensionCountdown.vue'
import { AUTO_EXTENSION_NOTICE_MINUTES } from '@/views/composable/useAutoExtensionCountdown'

// 自動延長のトグル＋「延長：コース名」＋予告カウントダウンをまとめた区画。
// 3カラム概要(SessionColumn)と旧1カラム概要(LegacyOverview)の両方で使い回す。
export default {
  components: {
    AutoExtensionToggle,
    AutoExtensionCountdown,
  },
  props: {
    tableId: {
      type: [Number, String],
      required: true,
    },
    expireAt: {
      type: String,
      default: null,
    },
    autoExtensionEnabled: {
      type: Boolean,
      default: false,
    },
    autoExtensionCourseName: {
      type: String,
      default: null,
    },
  },
  setup() {
    // 予告の発火は終了の1分前固定（終了通知設定とは独立）
    return { noticeMinutes: AUTO_EXTENSION_NOTICE_MINUTES }
  },
}
</script>

<style lang="scss" scoped>
.auto-extension-panel__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0;
  border-bottom: 1px solid var(--overview-border, rgba(255, 255, 255, 0.07));
  font-size: 15px;
}

.auto-extension-panel__label {
  opacity: 0.6;
}

.auto-extension-panel__course {
  font-size: 13px;
  opacity: 0.7;
  padding: 2px 0 4px;
}
</style>
